import { Link } from 'react-router-dom';
import { forexBasicsNextSteps } from '@/mocks/forexBasics';
import SectionHeading from '@/components/base/SectionHeading';
import ScrollReveal from '@/components/base/ScrollReveal';

export default function NextLearningStep() {
  return (
    <section className="border-t border-background-200 bg-background-100/60">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20 lg:px-10">
        <SectionHeading
          eyebrow="ก้าวต่อไป"
          title="พร้อมแล้ว ไปต่อที่การเทรดจริง"
          subtitle="เมื่อเข้าใจพื้นฐานครบแล้ว ขั้นต่อไปคือเรียนรู้วิธีเทรด Forex และฝึกใช้แพลตฟอร์ม MT4 / MT5 อย่างเป็นขั้นตอน"
        />

        <div className="mt-12 grid grid-cols-1 gap-5 lg:grid-cols-2">
          {forexBasicsNextSteps.map((step, index) => (
            <ScrollReveal key={step.to} delay={index * 90}>
              <Link
                to={step.to}
                className={`group flex h-full flex-col rounded-2xl border p-6 transition-all duration-300 ease-out hover:-translate-y-0.5 md:p-8 ${
                  step.accent
                    ? 'border-primary-200 bg-background-50 hover:border-primary-400'
                    : 'border-background-200 bg-background-50 hover:border-primary-300'
                }`}
              >
                <div className="flex items-center justify-between">
                  <span
                    className={`flex h-12 w-12 items-center justify-center rounded-xl ${
                      step.accent ? 'bg-primary-500 text-background-50' : 'bg-primary-100 text-primary-600'
                    }`}
                  >
                    <i className={`${step.icon} text-xl`} />
                  </span>
                  <span className="font-num text-sm font-semibold text-background-300">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                </div>

                <h3 className="mt-5 font-heading text-lg font-semibold text-foreground-950 md:text-xl">
                  {step.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{step.desc}</p>

                <ul className="mt-5 grid grid-cols-1 gap-2.5 sm:grid-cols-2">
                  {step.items.map((item) => (
                    <li key={item} className="flex items-start gap-2 text-sm text-foreground-700">
                      <i className="ri-check-line mt-0.5 text-sm text-accent-600" />
                      <span className="leading-snug">{item}</span>
                    </li>
                  ))}
                </ul>

                <span className="mt-6 flex items-center gap-1.5 border-t border-background-200 pt-4 text-sm font-semibold text-primary-600">
                  {step.cta}
                  <i className="ri-arrow-right-line text-base transition-transform group-hover:translate-x-0.5" />
                </span>
              </Link>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}